
import {FC} from "react";

import React from 'react';

import ApprovalCloseForm from "../../forms/claim-handling-forms/approval-close-form";

interface Interface{
    requestId: any;
    partSource: any;
    mode?: "View" | "Add new";
    onClose?: () => void;
}

const ApprovalCloseScreen: FC<Interface> = (props:any) => {

    

    return (
            
                <ApprovalCloseForm
                    requestId={props.requestId}
                    partSource={props.partSource}
                    mode={props.mode}
                />
            
    );
}
export default ApprovalCloseScreen;
